module.exports = __webpack_public_path__ + "static/media/helmet-common.efe2a8c4.png";